export const carouselSettingState = {
    errorCode : 0,
    statusCode : 0,
    carouselList : [],
    message : '',
    UpdatedList : []
}